import {Component, signal, OnInit} from '@angular/core';
import {FormGroup, FormControl, Validators, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {HttpClientModule} from "@angular/common/http";
import {catchError, map, shareReplay, startWith, switchMap, tap} from "rxjs/operators";
import {Observable, of} from "rxjs";
import {UserService} from '@services/user.service';
import {ApiService} from '@services/api.service';
import {UtilsService} from '@services/utils.service';
import {Base64Model, CreateTypeInput} from '../../models/input.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  ExerciseType,
  ExerciseTypeListResponse,
  RequestCreateResponse, RequestType,
  RequestTypeListResponse
} from '../../models/output.model';
import {ModalService} from '@services/modal.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-request-form',
  imports: [HttpClientModule, ReactiveFormsModule, CommonModule],
  templateUrl: './request-form.component.html',
  styleUrl: './request-form.component.css'
})
export class RequestFormComponent implements OnInit {

  selectedFiles: File[] = [];
  base64Files: Base64Model[] = [];
  result: string = '';

  requestTypes$!: Observable<RequestType[]>;
  filteredRequestTypes$!: Observable<RequestType[]>;
  exerciseTypes$!: Observable<ExerciseType[]>;
  requestTypeDescription: SafeHtml = '';

  requestForm! : FormGroup

  submitted = signal(false);


  constructor(
    private userService: UserService,
    private apiService: ApiService,
    private utilSvc: UtilsService,
    private sanitizer: DomSanitizer,
    private modalService: ModalService,
    private router: Router,
    ) {
  }

  ngOnInit() {
    this.fetchRequestTypes();
    this.fetchExerciseTypes();
    this.requestForm = new FormGroup({
      name: new FormControl({value:this.userService.getUser()?.name, disabled: true}, [Validators.required], ),
      mail: new FormControl({value:this.userService.getUser()?.username, disabled: true}, [Validators.required, Validators.email]),
      request_type_id: new FormControl('', Validators.required),
      exercise_type_id: new FormControl('', Validators.required),
      notes: new FormControl('', Validators.required),
      attachments: new FormControl<Base64Model[]>([])
    });

    this.filteredRequestTypes$ = this.requestForm.get('exercise_type_id')!.valueChanges.pipe(
      startWith(this.requestForm.get('exercise_type_id')?.value),
      switchMap(selectedExerciseTypeId =>
        this.requestTypes$.pipe(
          map(types => types.filter(t =>
            t.exercise_type_id === "" || t.exercise_type_id === selectedExerciseTypeId
          ))
        )
      )
    );

/*
    let mailForm = this.requestForm.get("mail") as FormControl
    let nameForm = this.requestForm.get("name") as FormControl
    if (mailForm) {
      mailForm.setValue(this.userService.getUser()?.username);
    }
    if (nameForm) {
      nameForm.setValue(this.userService.getUser()?.name);
    }*/
  }

  fetchRequestTypes() {

    this.requestTypes$ = this.apiService.getRequestTypes().pipe(
      map((response: RequestTypeListResponse) => response.data.sort((a:RequestType, b:RequestType) => a.label.localeCompare(b.label))),
      shareReplay(1),
      catchError(error => {
        console.error("Errore nel recupero dei types", error);
        return of([])
      })
    )
  }

  fetchExerciseTypes() {
    this.exerciseTypes$ = this.apiService.getExerciseTypes().pipe(
      map((response: ExerciseTypeListResponse) => response.data.sort((a:ExerciseType, b:ExerciseType) => a.label.localeCompare(b.label))),
      catchError(error => {
        console.error("Errore nel recupero dei types", error);
        return of([])
      })
    )
  }

  onRequestTypeChange(event: Event, obs: RequestType[]) {
    const selectedElement = event.target as HTMLSelectElement;

    const selectedRequestType: RequestType | undefined  = obs.find((r :RequestType) => r.id == +selectedElement.value);

    this.requestTypeDescription = this.sanitizer.bypassSecurityTrustHtml(selectedRequestType?.description || "") ;


    const attachmentControl = this.requestForm.get('attachments');
    if (attachmentControl) {
      if (selectedRequestType?.requires_attachment) {
        attachmentControl.setValidators(Validators.required);
      } else {
        attachmentControl.setValidators(null);
      }
      attachmentControl.updateValueAndValidity()
    }
  }

  onFileSelected(event: Event) {
    this.selectedFiles = [];
    this.base64Files = [];
    this.utilSvc.onFileSelected(event , this.selectedFiles, this.base64Files )
  }

  newRequest() {
    this.submitted.set(false);
    this.requestForm.reset();
    this.requestForm.get("mail")?.setValue(this.userService.getUser()?.username);
    this.requestForm.get("name")?.setValue(this.userService.getUser()?.name);
    this.requestTypeDescription = ""
    this.result = '';
  }

  onSubmit() {
    if (this.requestForm.valid) {

      const formData: CreateTypeInput = {
        ...this.requestForm.value,
        attachments: this.base64Files
      }
      //formData.request_type_id = +formData.request_type_id

      this.apiService.createRequest(formData).subscribe({
        next: (response: RequestCreateResponse) => {
          this.submitted.set(true);
          const body = {
            statusText: response.result.data?.uuid ? "Operazione eseguita con Successo" : (response.result?.message || "Errore"),
            message: response.result.data?.uuid ? "Richiesta inviata Correttamente" : "Ops qualcosa è andato storto"
          }
          this.modalService.showMessage(body)
        },
        error: (error) => {
          this.result = error.error.message
          this.modalService.showMessage(error)
        },
        complete: () => {
          this.router.navigate(['/my-requests']).then()
        }
      });

    }
  }

}
